module.exports = __webpack_public_path__ + "img/search-header-nav-below-kia.6e41be26.png";